import React, { PureComponent } from 'react';
import Hero from './pageComponents/Hero.js';
import KanseiBukanMap from './pageComponents/KanseiBukanMap.js';
import SekigaharaMap from './pageComponents/SekigaharaMap.js';
import TozamaDistance from './pageComponents/TozamaDistance.js';
import FudaiDistance from './pageComponents/FudaiDistance.js';
import Footer from './pageComponents/Footer.js'
// import Slope from './pageComponents/Slope.js';
import './App.css';

class App extends PureComponent {
  render(){
    return (
      <div className="bg-midori">
        <Hero />
        <KanseiBukanMap />
        <TozamaDistance class="w-full" />
        <SekigaharaMap />
        <FudaiDistance />
        <Footer />
      </div>
    )
  }
}

export default App;


// https://stackoverflow.com/questions/64665827/react-leaflet-center-attribute-does-not-change-when-the-center-state-changes